import { format } from 'date-fns';
import { fi } from 'date-fns/locale';

export function formatCurrency(data) {
  if (!data) return '';

  let amount;
  let currency;

  if (typeof data === 'object') {
    amount = data.amount;
    currency = data.currency;
  } else {
    // Fallback if it's just a number
    amount = data;
  }

  try {
    return new Intl.NumberFormat('fi-FI', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(amount || 0);
  } catch (e) {
    return `${amount?.toLocaleString() ?? '0'} ${currency || ''}`;
  }
}

export function formatDate(date, formatStr = 'P') {
  if (!date) return '-';
  try {
    return format(new Date(date), formatStr, { locale: fi });
  } catch (e) {
    return date;
  }
}

export function formatPercent(value, decimals = 0) {
  if (value === null || value === undefined) return '-';
  try {
    return new Intl.NumberFormat('fi-FI', {
      style: 'percent',
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(value);
  } catch (e) {
    return `${(value * 100).toFixed(decimals)}%`;
  }
}

export function formatMoveState(state) {
  const mapping = {
    done: 'Done',
    partially_available: 'Partial backorder',
    assigned: 'Ready',
    confirmed: 'On backorder',
  };

  return mapping[state] || state;
}

export const currencySortingFn = (rowA, rowB, columnId) => {
  const valA = rowA.getValue(columnId);
  const valB = rowB.getValue(columnId);
  const amountA = (typeof valA === 'object' && valA !== null) ? (valA.amount ?? 0) : (valA ?? 0);
  const amountB = (typeof valB === 'object' && valB !== null) ? (valB.amount ?? 0) : (valB ?? 0);
  return amountA - amountB;
};
